import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mm_token');
    const u = localStorage.getItem('mm_user');
    const t = localStorage.getItem('mm_tenant');
    if (token && u && t) {
      try {
        setUser(JSON.parse(u));
        setTenant(JSON.parse(t));
      } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('mm_token', data.access_token);
    localStorage.setItem('mm_user', JSON.stringify(data.user));
    localStorage.setItem('mm_tenant', JSON.stringify(data.tenant));
    setUser(data.user);
    setTenant(data.tenant);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('mm_token', data.access_token);
    localStorage.setItem('mm_user', JSON.stringify(data.user));
    localStorage.setItem('mm_tenant', JSON.stringify(data.tenant));
    setUser(data.user);
    setTenant(data.tenant);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('mm_token');
    localStorage.removeItem('mm_user');
    localStorage.removeItem('mm_tenant');
    setUser(null);
    setTenant(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
